const defaultState = {
  customer: {},
  error: null,
  saving: false,
  saved: false
};

const addEditCustomerReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_EDIT_CUSTOMER_SAVE_PENDING': {
      return {
        ...state, saving: true, error: null
      };
    }
    case 'ADD_EDIT_CUSTOMER_SAVE_FULFILLED': {
      return {
        ...state, saving: false, error: null, saved: true, newCustomer: action.payload
      };
    }
    case 'ADD_EDIT_CUSTOMER_SAVE_REJECTED': {
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default addEditCustomerReducer;


// WEBPACK FOOTER //
// ./src/reducers/addEditCustomer.js